import { useEffect, useState } from 'react';
import { consumeSessionReplacedNotice, SESSION_REPLACED_MESSAGE } from '../utils/sessionNotice';

export function SessionReplacedBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (consumeSessionReplacedNotice()) setShow(true);
  }, []);
  if (!show) return null;
  return (
    <div
      role="status"
      className="mb-4 rounded-xl bg-amber-50 border border-amber-200 px-4 py-3 text-sm text-amber-900 text-center font-medium"
    >
      {SESSION_REPLACED_MESSAGE}
    </div>
  );
}
